var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0AA2E",
    d: "m9.09 3.203-5.863 9.5a1.31 1.31 0 0 0-.004 1.338c.12.204.292.374.5.493.209.118.446.182.687.185h11.728c.242-.002.479-.066.687-.185.209-.12.381-.29.501-.493a1.31 1.31 0 0 0-.004-1.338l-5.864-9.5a1.37 1.37 0 0 0-.504-.474 1.42 1.42 0 0 0-1.359 0 1.37 1.37 0 0 0-.505.474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M10.273 5.906a.75.75 0 0 1 .75.75v2.688a.75.75 0 1 1-1.5 0V6.656a.75.75 0 0 1 .75-.75M9.523 12.031a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 0 1.5h-.008a.75.75 0 0 1-.75-.75"
  })));
};
export default SvgWarning;